import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]
  static values = {
    seconds: { type: Number, default: 60 },
    label: String,
    startActive: { type: Boolean, default: false }
  }

  connect() {
    this.timeout = null
    this.interval = null

    if (this.startActiveValue) {
      this.start()
    }
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    window.clearInterval(this.interval)
  }

  start() {
    if (!this.hasButtonTarget) return
    if (this.interval) return

    this.remaining = this.secondsValue
    this.buttonTarget.disabled = true
    this.buttonTarget.classList.add("disabled")
    this.updateLabel()

    this.interval = window.setInterval(() => {
      this.remaining -= 1
      this.updateLabel()

      if (this.remaining <= 0) {
        this.reset()
      }
    }, 1000)
  }

  updateLabel() {
    if (!this.hasButtonTarget) return

    this.buttonTarget.textContent = `Reenviar em ${this.remaining}s`
  }

  reset() {
    window.clearInterval(this.interval)
    this.interval = null

    if (!this.hasButtonTarget) return

    this.buttonTarget.disabled = false
    this.buttonTarget.classList.remove("disabled")
    this.buttonTarget.textContent = this.labelValue || "Reenviar código"
  }
}
